import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import MultiSelect from './multiSelect';

const FilterByFlag = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByFlag, messagesFlagFilters }
  } = localizedStrings;
  return (
    <div>
      <MultiSelect
        label={filterByFlag}
        options={messagesFlagFilters.map(item => ({
          label: item.text,
          value: item.value
        }))}
        value={filters.flag}
        updateFilters={value => {
          setFilters({ ...filters, flag: value });
        }}
      />
    </div>
  );
};

FilterByFlag.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByFlag;
